import { CLASS_ROUTE, EDU_ROUTE } from "@/constant/urlConstant";
import { useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { tokenState } from "state";
import { api, marketUrl } from "utils/util";
import { useMemo } from "react";
import { CHICRUITING_LANDING_PATH } from "@/constant/urlConstant";
import { DEVICE_INQUIRY_PATH } from "@/constant/urlConstant";

export default function useHeaderTabs() {
  const token = useRecoilValue(tokenState);
  const user = token && token.user_type;

  const { data: boardCategories } = useQuery(
    "boardCateCd",
    () => api?.get("/board/cate_cd").then((res) => res.data.cate_list),
    {
      cacheTime: 15 * 60 * 1000,
      staleTime: 15 * 60 * 1000,
    },
  );

  const boardList = boardCategories?.map((boardCategory: any) => {
    return { ...boardCategory, url: `/post?cate=${boardCategory.cate_cd}` };
  });

  return useMemo(() => {
    const baseTabs = [
      {
        label: "기기 문의",
        value: "device-inquiry",
        url: DEVICE_INQUIRY_PATH,
        width: 60,
        // PC 는 새 탭, 모바일 퀵메뉴(HomeMenu)는 window.open 으로 인앱브라우저 처리
        external: true,
        subTabs: [],
      },
      {
        label: "리쥬메이트",
        value: "rejumate",
        url: "/rejumate",
        width: 116,
        subTabs: [],
      },
      // 슈링크 GNB 한시적 숨김 (요청: 약 1개월)
      // {
      //   label: "슈링크",
      //   value: "shurink",
      //   url: "/shurink",
      //   width: 82,
      //   subTabs: [],
      // },
      {
        label: "레이",
        value: "ray",
        url: "/ray",
        width: 78,
        subTabs: [],
      },
      {
        label: "클래스",
        value: "class",
        url: "/class",
        width: 36,
        subTabs: [
          { cate_name: "클래스", value: "class", url: `/${CLASS_ROUTE}` },
          { cate_name: "보수교육", value: `edu`, url: `/${EDU_ROUTE}` },
        ],
      },
      {
        label: "마켓",
        value: "market",
        url: marketUrl(),
        width: 24,
        subTabs: [],
      },
      {
        label: "콘텐츠",
        value: "contents",
        url: "/contents",
        width: 36,
        subTabs: [],
      },
      {
        label: "게시판",
        value: "post",
        url: "/post",
        width: 36,
        subTabs: token && boardList ? boardList : [],
      },
      {
        label: "Q&A/임상",
        value: "qna",
        url: `/qna/${user === "student" ? "student" : "doctor"}`,
        width: 88,
        subTabs: [
          { cate_name: "치과의사 Q&A", value: "doctor", url: "/qna/doctor" },
          { cate_name: "임상포럼", value: "forum", url: "/forum" },
          { cate_name: "치대생 Q&A", value: "student", url: "/qna/student" },
        ],
      },
      {
        label: "개원/경영",
        value: "management",
        url: "/management",
        width: 54,
        subTabs: [
          { cate_name: "전체", value: "all", url: "/management/home" },
          { cate_name: "컨설팅", value: "consulting", url: "/management/consulting" },
          { cate_name: "금융/대출", value: "loan", url: "/management/loan" },
          { cate_name: "기공소", value: "lab", url: "/management/lab" },
          { cate_name: "감염관리", value: "infection", url: "/management/infection" },
          { cate_name: "세무/노무", value: "taxlabor", url: "/management/taxlabor" },
          { cate_name: "상영관", value: "theater", url: "/management/theater" },
          { cate_name: "병원 양도/임대", value: "estate", url: "/management/estate" },
          { cate_name: "중고장터", value: "market", url: "/management/market" },
        ],
      },
      {
        label: "치크루팅",
        value: "chicruiting",
        url: CHICRUITING_LANDING_PATH,
        width: 74,
        subTabs: [],
      },
      {
        label: "구인구직",
        value: "recruit",
        url: "/recruit/doctor",
        width: 48,
        subTabs: [],
      },
      {
        label: "세미나",
        value: "seminar",
        url: "/management/seminar",
        width: 36,
        subTabs: [
          { cate_name: "세미나", value: "seminar", url: "/management/seminar" },
          { cate_name: "주간세미나", value: "seminar_weekly", url: "/management/seminar_weekly" },
        ],
      },
      {
        label: "공동구매관",
        value: "expo",
        url: "/expo",
        width: 72,
        subTabs: [],
      },
      // {
      //   label: "전치제",
      //   value: "festival",
      //   url: "/festival",
      //   width: 36,
      //   subTabs: [],
      // },
    ].filter(Boolean) as {
      label: string;
      value: string;
      url: string;
      external?: boolean;
      width: number;
      subTabs: { cate_name: string; value: string; url: string; isExternal?: boolean }[];
    }[];

    return baseTabs;
  }, [boardList]);
}
